<template>
  <v-container fluid style="width: 100%; padding: 0">
    <Header />
    <article class="text-center1 mobile-center1 v-full-height splash">
      <section class="fw-section">
        <div class="container fullwidthsec">
          <div class="row" style="padding-top: 50px">
            <div class="page-title title-size-normal text-dark">
              <div class="container white1">
                <div class="inner white1">
                  <div class="column white1">
                    <center>
                      <div class="titlelogin">
                        Log in to your Maposcope account
                      </div>
                    </center>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-3"></div>
            <div class="col-sm-6">
              <div class="form-group padding-bottom-2x">
                <div class="row padding-bottom-1x">
                  <div class="col-xs-0 text-left"></div>
                  <div class="col-xs-12 text-right">
                    <router-link to="signup">
                      New here? Sign up for free.
                    </router-link>
                  </div>
                </div>
                <label for="email" class="control-label white1">Email</label>
                <input
                  type="text"
                  v-model="email"
                  name="email"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && !email }"
                  tabindex="110"
                />
                <div v-show="submitted && !email" class="invalid-feedback">
                  Email is required
                </div>
              </div>

              <div class="form-group">
                <div class="row padding-bottom-1x">
                  <div class="col-xs-0 text-left"></div>
                  <div class="col-xs-12 text-right">
                    <router-link to="forgot-password">
                      Forgot password?</router-link
                    >
                  </div>
                </div>
                <label for="password" class="control-label white1"
                  >Password</label
                >
                <input
                  type="password"
                  v-model="password"
                  name="password"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && !password }"
                />
                <div v-show="submitted && !password" class="invalid-feedback">
                  Password is required
                </div>
              </div>

              <div class="form-group">
                <p class="subtitle error-msg">{{ errorMsg }}</p>
                <button
                  class="btn btn-ghost1 btn-rounded btn-default btn-block waves-effect1 waves-light1 btnl1"
                  type="submit"
                  @click="login()"
                >
                  Sign in
                </button>
              </div>
            </div>
          </div>
          <div class="col-sm-3"></div>
        </div>
        <div class="page-title title-size-normal text-dark">
          <center>
            <button @click="openGooglePlay">
              <img
                src="/img/get_googleplay.png"
                alt="Maposcope on Google Play"
                style="padding-right: 20px"
              />
            </button>

            <button @click="openAppstore">
              <img
                src="/img/get_appstore2.png"
                alt="Maposcope on Apple Appstore"
                style="padding-left: 20px"
              />
            </button>
          </center>
        </div>
      </section>
    </article>
    <Footer />
    <vue-cookies-consent
      backgroundButton="#1972f5"
      borderRadius="5"
      backgroundButtonHover="#3A4F52"
      offsetY="5"
      style="z-index: 1000"
    >
      <template #description>
        <p>
          We use cookies to ensure you get the best experience on our website
          <router-link to="privacy-policy"
            ><span style="color: #0a64eb">Read more</span></router-link
          >
        </p>
      </template>
      <template #button>Accept cookies</template>
    </vue-cookies-consent>
  </v-container>
</template>

<script>
import Header from "./Header.vue";
import Footer from "./Footer.vue";
import VueCookiesConsent from "@norvikit/vue-cookies-consent";
export default {
  components: {
    Header,
    Footer,
    VueCookiesConsent,
  },
  data() {
    return {
      email: "",
      password: "",
      errorMsg: "",
    };
  },
  computed: {},
  methods: {
    login() {
      this.$store
        .dispatch("auth/login", { email: this.email, password: this.password })
        .then(
          (data) => {
            if (data.success == 1) {
              this.errorMsg = "";
              this.$router.push({
                name: "Routes",
              });
            }
          },
          (data) => {
            this.errorMsg = data["message"];
          }
        );
    },
    openGooglePlay() {
      window.open(
        "https://play.google.com/store/apps/details?id=com.mapamai.maps.batchgeocode",
        "_blank"
      );
    },
    openAppstore() {
      window.open(
        "https://apps.apple.com/pl/app/maposcope-fast-route-planner/id1502155614",
        "_blank"
      );
    },
  },
};
</script>


<style scoped>
a {
  color: red;
}
.error-msg {
  color: red;
  font-weight: bold;
}

.wlink a,
a:active,
a:hover {
  color: #ffffff !important;
}
.v-application a {
  color: #ffffff !important;
}

.btnl1 {
  color: #ffffff !important;
  background-color: #1972f5;
}

.btnl1:hover {
  background-color: #0a64eb;
}
.fullwidthsec {
  max-width: 1200px;
}
@media only screen and (max-width: 600px) {
  .fullwidthsec {
    max-width: 350px;
  }
}
</style>